import axios from 'axios'

import store from '~/store'
import * as types from '../mutation-types'

const {randomString} = require('../../plugins/helper')

const { objectToFormData } = require('../../plugins/objectToFormData')

export const state = {
  loading: true,
  message: {},
  error: null,
  loadingChangeMessageStatus: true,
  changeMessageStatus: {},
  errorChangeMessageStatus: null,
}

export const mutations = {
  [types.SET_FILE_MESSAGE_ACTIVE_START](state) {
    state.loading = true
    state.message = []
    state.error = null
  },

  [types.SET_FILE_MESSAGE_ACTIVE_SUCCESS](state, { data }) {
    state.loading = false
    state.message = data
    state.error = null
  },

  [types.SET_FILE_MESSAGE_ACTIVE_ERROR](state, { error }) {
    state.loading = false
    state.message = []
    state.error = error
  },

  [types.CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_START](state) {
    state.loadingChangeMessageStatus = true
    state.changeMessageStatus = {}
    state.errorChangeMessageStatus = null
  },

  [types.CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_SUCCESS](state, { data }) {
    state.loadingChangeMessageStatus = false
    state.changeMessageStatus = data
    state.errorChangeMessageStatus = null
  },

  [types.CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_ERROR](state, { error }) {
    state.loadingChangeMessageStatus = false
    state.changeMessageStatus = {}
    state.error = error
  },
}

export const actions = {
  async assignFileToClient({ commit }, {roomId, message, value}) {
    try {
      commit(types.SET_FILE_MESSAGE_ACTIVE_START)

      const form = objectToFormData({
        roomId,
        _id: message._id,
        senderId: message.senderId,
        files: message.files,
        value,
      })
      const { data } = await axios.post(`/api/sale/messages/${roomId}/assign_file_to_client`, form)

      store.dispatch('setUpdateStatus', randomString(10))

      commit(types.SET_FILE_MESSAGE_ACTIVE_SUCCESS, { data })
    } catch (e) {
      commit(types.SET_FILE_MESSAGE_ACTIVE_ERROR, { error: null })
    }
  },
  async changeStatusToReadByTheProcessor({ commit }, {roomId}) {
    try {
      commit(types.CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_START)

      const { data } = await axios.post(`/api/sale/messages/${roomId}/change_message_status`)

      commit(types.CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_SUCCESS, { data })
    } catch (e) {
      commit(types.CHANGE_STATUS_TO_READ_BY_THE_PROCESSOR_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingSetFileMessageActive: state => state.loading,
  messageSetFileMessageActive: state => state.message,
  errorSetFileMessageActive: state => state.error,
  loadingChangeMessageStatus: state => state.loadingChangeMessageStatus,
  changeMessageStatus: state => state.changeMessageStatus,
  errorChangeMessageStatus: state => state.errorChangeMessageStatus,
}
